export default __webpack_public_path__ + "static/media/535.0fdf5fae.jpg";